import { useContext, useEffect } from 'react';
import { useFieldOptions } from './useFieldOptions';
import { useFilterFamilyOptions } from './useFilterFamilyOptions';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
export const useSelectOnlyFilterFamilyAndField = () => {
  const {
    selectedFilterFamily,
    selectedFilterFamilyGroup
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    selectTheOnlyFilterFamily
  } = useFilterFamilyOptions();
  const {
    selectTheOnlyField
  } = useFieldOptions( // @ts-expect-error The function fetched is only used when selectedFilterFamily is defined
  selectedFilterFamily === null || selectedFilterFamily === void 0 ? void 0 : selectedFilterFamily.filterFamily, '');
  useEffect(() => {
    if (!selectedFilterFamily && !selectedFilterFamilyGroup) {
      selectTheOnlyFilterFamily();
    }
  }, [selectedFilterFamily, selectedFilterFamilyGroup, selectTheOnlyFilterFamily]);
  useEffect(() => {
    selectTheOnlyField();
  }, [selectTheOnlyField]);
};